(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    const initAutoplayFallback = () => {
    const deferredEls = document.querySelectorAll('deferred-media[autoplay]');
    if (!deferredEls.length) return;

    deferredEls.forEach((dm) => {
      if (dm.dataset.tkrAutoplayInit === '1') return;
      dm.dataset.tkrAutoplayInit = '1';

      const overlayBtn = dm.querySelector('[data-tkr-autoplay-fallback]');
      const video = dm.querySelector('video');

      // Only HTML5 <video> can be handled reliably here
      if (!video) return;

      const showFallback = () => {
        video.controls = true;
        overlayBtn?.classList.remove('hidden');
      };

      const hideFallback = () => {
        overlayBtn?.classList.add('hidden');
      };

      const attemptPlay = () => {
        // Best-effort attributes for mobile autoplay policies
        video.muted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.setAttribute('playsinline', '');

        const p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(() => {
            // If autoplay works, keep the UI clean
            if (!video.paused) hideFallback();
          }).catch(() => {
            showFallback();
          });
        }
      };

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              attemptPlay();
              io.disconnect();
            }
          });
        }, { threshold: 0.35 });
        io.observe(dm);
      } else {
        attemptPlay();
      }

      overlayBtn?.addEventListener('click', () => {
        video.controls = true;
        video.play().catch(() => {});
        hideFallback();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initAutoplayFallback);
  document.addEventListener('shopify:section:load', initAutoplayFallback);
  } catch(e) { console.error(e); }
})();

})();
